export default {
  'common.ReLogin': '重新登錄',
  'common.ChangePassword': '修改密碼',
  'common.Logout': '登出',
  'common.LoginStatusInvalid': '登錄狀態已失效，請重新登錄！',
  'common.BackHome': '返回首頁',
  'message.HTTP_403': '抱歉，您無權訪問此頁面。',
  'message.HTTP_404': '抱歉，您訪問的頁面不存在。',

  '+FDO1E': '進駐聯絡人郵箱',
  '/XxWUC': '自有海外倉直接填寫自有海外倉，如沒有，填寫「無」',
  '/q5fD8': '是否在英國/東南亞本地有海外倉',
  '01n1lw': '該品牌是否已在德國當地擁有R標',
  '0sn8j/': '請填寫姓名',
  '1wOLiI': '做獨立站意向',
  '2cyTCk': '已提交(需等待 {day1} 個工作日) ——> 初篩通過已同步提交給平台(需等待 {day2} 個工作日) ——> 平台通過',
  '2towDA': '美國站近一年銷售額(USD)',
  '387HdI': '是否有自建海外倉或第三方海外倉',
  '3K1yMY': '庫內監控材料',
  '49iOzF': '企業/品牌類型',
  '4L3xFT': '公司規模（員工數量）',
  '5grmob': '請填寫郵箱',
  '5rJPKe': '希望開通ManoMano的國家站點',
  '6C4ze5': '主要產品類目',
  '6jglbI': '品牌商標註冊地',
  '6nYN2s': '請選擇是否有自建海外倉或第三方海外倉',
  '6udigR': '公司性質',
  '7V8auA': '單品牌全渠道近一年的銷售額(USD)',
  '7gK7Rj': '在經營中的店鋪最近一季平均月銷售額(USD)',
  '7wp+GP': '其他電商平台單站點單帳號近一年的銷售額(USD)',
  '85GJe2': '帳號負責人電話',
  '8xAjhV': '賣家聯絡人信息',
  '9aEF/T': '店鋪貨源',
  '9bKiBE': '請務必確保郵箱可以接收郵件，發放註冊連結',
  'A3JVko': '營業執照公司名稱',
  'AyGOuG': '亞馬遜德國、eBay德國、Kaufland 或其他平台店鋪/獨立站後台截圖',
  'B4jhFM': '帳號註冊用郵箱',
  'BZ219V': '請填寫中文名稱',
  'BgUDFC': '進駐狀態',
  'D6nMUK': '主營類目',
  'DU8pzO': '請填寫公司法定名稱',
  'DcPRut': '請填寫您常用的QQ號',
  'DhEqZS': '您的微信號',
  'E92Gy6': '新增連結',
  'EL4b8j': '請填寫其他北美電商平台的「店鋪」連結',
  'EPp062': '德國公司名',
  'Ems0C9': '如有，請填寫海外倉服務商名',
  'EoXCE9': '業務模式',
  'F+ij7Y': '是否已辦理該德國公司的VAT',
  'FPYNcH': '請填寫1到11位數字',
  'GzrOsm': '申請的二級類目',
  'H26cpN': '20字以上，150字以內',
  'Hh+8lr': '填寫您目前主營產品類目',
  'IcnW+V': '其他北美電商平台的「店鋪」連結',
  'InYzo7': '您計劃是做英國市場還是東南亞市場',
  'Iv0cZc': '法人國籍',
  'JonMgV': 'SKU數量',
  'JzufF9': '您常用的QQ號',
  'KIfH+Q': '請填寫20到150位任意字符',
  'KQOzSw': '電子郵箱',
  'KqTHNC': '庫內截圖',
  'L4jOeD': '填寫主營的具體二級類目',
  'LxjC12': 'QQ號',
  'MdKKAC': '其他電商平台的店鋪連結',
  'NG02nv': '公司所在區域',
  'NuSU2V': '中文填寫',
  'Nwgq9f': '是否擁有德國當地海外倉',
  'OOfHj5': '法人姓名',
  'Ot/X5z': '進駐聯絡人信息',
  'P6ktCt': '填寫中文名',
  'P8S+b1': '是否有德語客服人員',
  'R4mfIu': '例如，亞馬遜店鋪/速賣通店鋪/天貓/京東/獨立站優先，或其他',
  'SNeIpX': '亞馬遜歐洲站, Allegro, Fnac/darty 等等',
  'U3/OiC': '其他歐洲電商平台店鋪連結',
  'Uo35I9': '點擊影片連結打開影片（只有已申請查詢並獲取影片的單據有庫內影片資訊，超期檔案無法打開）',
  'VFVI+w': '填寫具體金額',
  'VwT6Ym': '請填寫金額',
  'WIRiiO': '主營產品（具體二級類目）',
  'WXHb1+': '請務必保持電話暢通，將作為後續主要聯絡方式',
  'X+Zymb': '公司簡介或者羅列出公司的優勢',
  'XEsuFF': '請填寫主營產品',
  'XXh7Kw': '營業執照中文名稱',
  'XwN70f': '請填寫亞馬遜德國, eBay德國, Kaufland,或者其他平台店鋪/獨立站連結',
  'Y0L01Z': '正在營運的歐美跨境電商平台連結',
  'YI7fqG': '第三方平台連結',
  'Z1d1dA': '進駐品牌名',
  'ZcMSoa': '請填寫營業執照公司名稱',
  'aIq9ik': '其他（eBay、Amazon）北美電商平台單站點單帳號近一年的銷售額(USD)',
  'aidSjp': '點擊截圖連結下載檔案（只有已申請查詢並獲取影片的單據有庫內截圖資訊，超期檔案無法打開）',
  'bN8SdN': '企業/品牌簡介',
  'bNQ47y': '重新編輯',
  'bilPnX': '公司主營產品',
  'c9DIEs': '填寫英文或漢語拼音 例：中- Zhang San or 英- Rachel Green',
  'crZAUj': '申請人QQ號',
  'csAYl3': '電子產品類目必須填寫是否有Weee',
  'd+drZB': '如果有 請填寫 將有機會對接引流項目',
  'fqBdzm': '公司法定名稱',
  'gGYhmd': '帳號負責人姓名',
  'gKaGa2': '填寫美國站銷售平台（是否有亞馬遜/沃爾瑪/獨立站）',
  'gP+ldf': '進駐聯絡人姓名',
  'gVUjRH': '請務必確保電話暢通',
  'gqZa18': '中國公司辦地址',
  'hC7WeL': '企業/品牌官網',
  'i2HQKK': '進駐聯絡人電話',
  'i8orsr': '銷售額',
  'iTutLd': '您擁有的品牌名稱',
  'jJeioA': '法人',
  'k0TWda': '正在使用的獨立站平台',
  'kUTW+Q': '申請人電話',
  'l+0j0U': '以上電商平台過去30天銷售額',
  'lC0TIO': '請填寫具體金額',
  'lCo8xA': '請填寫1到20位數字',
  'm8yqtX': '請填寫微信號',
  'mkiqo/': '中國公司名',
  'nVPQ6u': 'Shopify獨立站網址',
  'nbGLjI': '庫內影片',
  'oFGnIc': '中國公司的營業執照{break}德國公司的營業執照{break}法人手持護照和身份證的拍照件{break}德國當地海外倉的發貨證明{break}德語客服人員的德語證書',
  'pKBw1k': '{platform} 進駐申請',
  'pb7ufS': '帳號負責人郵箱',
  'pe5tUK': '美國站銷售平台',
  'pnPqSu': '公司全名',
  'q9+Dhh': '請填寫註冊郵箱',
  'qDJlru': '客單價 (USD)',
  'qDga7W': '您距離進駐成功需要等多久：',
  'qjVIUB': '海外倉服務商名稱',
  's7Ufrr': '是否有直播/短影片運營經驗',
  'u1sMF4': '請提供證件並打包發送',
  'u6/UxU': '請提供以下證件並打包發送',
  'udZJ3q': '只填數字，不需要貨幣符號',
  'uqYkNh': '如沒有操作過其他平台 填「否」，如有請填寫具體金額',
  'v725h2': '請填寫電話',
  'v8b14F': '請填寫聯絡人姓名',
  'vc/KMI': '立即進駐',
  'w+7yLR': '跨境電商近一年銷售額(USD)',
  'w6hWi5': '帳號負責人微信',
  'x6NFpn': '客戶單價 (USD)',
  'xToKvz': 'TikTok帳號名稱（沒有請填無）',
  'yMUv2D': '請填寫1到60位任意字符',
  'q1fRx5': '亞馬遜德國，eBay德國，Kaufland等店鋪的後台銷售截圖',

};
